import React from 'react';
import Main from '../../components/Main';
import { useNavigate } from 'react-router-dom';
import {Row, Col, Image, Button } from 'react-bootstrap';
import LongCard from '../../components/LongCard';
import register from '../../assets/images/register.png';

// Clients Subpage of AboutUs Page

import '../../assets/styles/Global.css';


const icons = {};
const partners ={};

function importAll(r, images) {
  r.keys().forEach((key) => {
    images[key.replace('./', '')] = r(key);
  });
}

// Imports all images from the clients folder into the images array

importAll(require.context('../../assets/images/aboutus_icons/clients', false, /\.(png|jpe?g|svg)$/), icons);
importAll(require.context('../../assets/images/aboutus_icons/clients/partners', false, /\.(png|jpe?g|svg)$/), partners);


const clients = [
  {
    title: "Specialized in delivering business outcomes",
    description: "Every project is supported by relevant performance indicators ",
    details : `At IQosys, we specialize in designing and deploying groundbreaking business models, processes, and products & services through the use of cutting-edge technologies. Our expertise lies in translating your visionary ideas into actionable strategies that drive real business results. Our assignments are typically supported by a preliminary business case, project-relevant KPIs and post deployment success metrics that enable your teams to ensure that there’s a positive ROI associated with each initiative.`,
    icon: icons['clients_1.png'],
  },
  {
    title: "Cross functional expertise",
    description: "Our transformation teams combine sector, functional and technical expertise",
    details : `To ensure the pertinence of our recommendations, we always strive to mobilize a cross-functional team that combines sector expertise, functional knowledge and technical experience. Our teams are directed by Executive Partners, who bring a wealth of expertise across a diverse mix of economic sectors, functional disciplines, and technology practices. Their hands-on experience and strategic insights ensure that every project we undertake is aligned with your unique business objectives and delivers maximum value. With IQosys, you're not just hiring a consulting firm; you're gaining access to some of the brightest minds in the industry.`,
    icon: icons['clients_2.png'],
  },
  {
    title: "Vast network of professionals",
    description: "We run a hybrid operating model of full-time and on-call consultants",
    details : `IQosys leverages a robust pool of internal and on-call consultants, providing you access to over 1 000 professionals across Europe and internationally. This extensive network allows us to tailor our teams precisely to your needs, ensuring that you have the right talent for every aspect of your project. No matter the challenge, we have the expertise to address it effectively.`,
    icon: icons['clients_3.png'],
  },
  {
    title: "Performance-based compensation",
    description: "All our projects contain success fees for full alignment with client objectives",
    details : `We believe in aligning our success with yours. Each project delivered by IQosys includes a base fee and a success fee tied to a range of performance KPIs such as technical knowledge, speed of delivery, or relationship building acumen. This unique model gives your project manager a strong and direct lever of control on every project, every week, ensuring peak performance throughout the engagement. Our success is directly linked to your satisfaction and project outcomes.`,
    icon: icons['clients_4.png'],
  },
  {
    title: "Stakeholder commitment",
    description: "IQosys consultants and Exec Partners are shareholders",
    details : `Every Exec Partner and Consultant at IQosys has access to equity in the company, making them strong stakeholders in the success of both our firm and your individual projects. This equity-based structure fosters a deep sense of ownership and commitment, ensuring that every member of our team is dedicated to achieving exceptional results for your organization.`,
    icon: icons['clients_5.png'],
  },
  {
    title: "End-to-end service excellence",
    description: "We don’t just advise … we build, run and then measure business results",
    details : `IQosys offers comprehensive, end-to-end services that cover every stage of your technology and business transformation journey. From technology vision engineering and strategic ideation to business cases, prototyping solutions, integrating with your existing tech stack, rolling out, maintaining, and measuring success. We are with you every step of the way.`,
    icon: icons['clients_6.png'],
  },
  {
    title: "Agility and Responsiveness",
    description: "Super short projects, fast turnaround … we’re here for you",
    details : `In today's fast-paced business environment, agility is key. IQosys prides itself on its extremely agile processes, with a typical turnaround time of just 5 working days between receiving a request and putting forward a qualified expert or cross-functional team. This level of responsiveness allows us to quickly mobilize the right resources and start delivering value to your organization without delay.`,
    icon: icons['clients_7.png'],
  },
];

const Clients = () => {
  const navigate = useNavigate();
  const handleRegisterClick = () => {
    navigate('/myaccount/register'); // Redirect to the Register page
  };

  return (
    <div>
      <Main componentList={[
      <h6 className="top_sentence">7 reasons why businesses prefer sourcing advisory services from IQosys</h6>,
      <h7>IQosys is your professional services partner for digital transformation initiatives. At IQosys, we understand that in today's rapidly evolving business environment, the ability to adapt and innovate is crucial for sustained success. Below are 7 reasons why partnering with IQosys enhances an organization’s ability to accelerate change and develop sustainable competitive advantages.</h7>,
      <Col className="mt-4">
        {clients.map((client, index) => (
          <Row md={6} lg={1} key={index}>
            <LongCard className="h-100 shadow-sm" longcard={client}/>
          </Row>
        ))}
      </Col>,
      <h7>Choosing IQosys means choosing a partner who is committed to driving your success through innovative solutions, deep expertise, and agile execution. Let's embark on this journey together and make your vision a reality.<br/> <br/>
        Some of IQosys Exec Partners combined consulting references are listed below:
      </h7>,
      <Row className="mt-4 justify-content-center">
        {[...Array(3)].map((_, rowIndex) => (
          <Row key={rowIndex} className="mb-4 justify-content-center">
            {[...Array(5)].map((_, colIndex) => (
              <Col
                key={colIndex}
                xs={6} sm={4} md={3} lg={2}
                className="d-flex justify-content-center align-items-center m-1"
                style={{
                  width: "18%",
                  maxWidth: "160px",
                  aspectRatio: "1 / 1",
                  padding: "20px",
                  border: "1px solid #d8d8d8",
                  borderRadius: "10px",
                }}
              >
                <Image
                  src={partners[`partners_${rowIndex * 5 + colIndex + 1}_rmv.png`]} fluid
                  className="partner-image"/>
              </Col>
            ))}
          </Row>
        ))}
      </Row>,

      <hr className="my-custom-hr"/>,
      <Button variant="light" 
        className="mt-auto btn-sm text-start align-self-start border-0"  
        onClick={handleRegisterClick}
        style={{ 
          backgroundColor: "white", 
          boxShadow: "none",
        }}
      >
        <div className="d-flex align-items-center" style={{marginBottom:"10px"}}>
          <Image src={register} width={32} height={32} alt="Register Icon" />
          <span className='ms-2' style={{color: "#7300FF", fontWeight: "bold"}}>Apply to join</span>
        </div>
      </Button>
      ]} />
    </div>
  );
};



export default Clients;